import React, { useEffect, useState } from "react";
import insytix from "../../Assets/whitelogoinsytix.png";
import Notificatons from "../../Assets/notifications.svg";
import Logout from "../../Assets/logoutNew.svg";
import HelpandSupport from "../../Assets/Usefullink.svg";
import EditProfile from "../../Assets/editProfile.svg";
import NavbarSc from "./index.sc";
import { getOrgUserDetails } from "../../api/users/getOrgUserDetails";
import { getInsytixAccess, getLoginEmail } from "../../api/InsytixEmployees";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Person,
  MagReview,
  Compenstation,
  LeaveManagement,
  Calendar,
  EmployeeDirectory,
  Blog,
  Queries,
  Training,
  ContactDetails,
} from "../../Assets/SidebarIcon";
import Login from "../../Auth/Login/newIndex";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { useAuthContext } from "../../hooks";
import { color } from "@mui/system";
import ToggleList from "./component";
import { getReportsToEmail } from "../../api/EmergencyPTO/get_reports_to_email";
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClick, setIsClick] = useState(false);
  const handleMenuToggle = () => {
    setIsOpen(!isOpen);
  };
  const navigate = useNavigate();
  const [user, setUser] = useState<any>([]);
  const auth = useAuthContext();
  const fetchOrgUser = async () => {
    const orgId = auth?.userInfo?.orgs?.[0]?.id;
    const orgUserId = auth?.userInfo?.orgs_user_id?.[0];
    if (orgId == null || orgUserId == null) return;
    setUser(await getOrgUserDetails(orgId, String(orgUserId)));
    console.log("works");
  };
  const homeData = [
    {
      profileName: "Thaamarai Kannan",
      role: "Associate Developer",
    },
  ];
  useEffect(() => {
    fetchOrgUser();
    const email = getLoginEmail(auth);
    if (!email) return;
    getInsytixAccess(auth?.userInfo?.orgs?.[0]?.id || 100000000001, email)
      .then((access) => {
        if (access?.is_admin) {
          setUser((current: any) => {
            const record =
              Array.isArray(current) && current[0]
                ? { ...current[0], is_admin: 1 }
                : { is_admin: 1 };
            return [record];
          });
        }
      })
      .catch(() => undefined);
  }, [auth?.userAttr, auth?.user, auth?.userInfo]);

  // && {
  //   id: 1,
  //   icon: <MagReview />,
  //   label: "Admin Perfomance Tracking",
  //   path: "/adminPerformance",
  //   description: "Loreum ipssum",
  //   color: "rgba(255, 192, 203, 0.5)",
  // };
  // console.log(
  //   adminPerformanceModule,
  //   "-------------acefwefnrwnferfnerfgnejngrn"
  // );
  const adminPerformanceModule = [
    {
      heading: "People Lead",
      list: [
        {
          id: 1,
          icon: <MagReview />,
          label: "People Lead",
          path: "/adminPerformance",
          description: "Loreum ipssum",
          color: "rgba(255, 192, 203, 0.5)",
        },
        {
          id: 1,
          icon: <MagReview />,
          label: "Employee Timesheet",
          path: "/employeeTimeSheet",
          description: "Loreum ipssum",
          color: "rgba(255, 192, 203, 0.5)",
        },
      ],
    },
  ];
  const adminNavbar = [
    {
      heading: "My Self",
      list: [
        {
          id: 56,
          icon: <EmployeeDirectory />,
          label: "Insytix Employees",
          path: "/insytix-employees",
          color: "rgba(111, 45, 137, 0.25)",
        },
        {
          id: 2,
          icon: <MagReview />,
          label: "HR Dashboard",
          path: "/adminleavemngmnt",
          color: "rgba(144, 238, 144, 0.781)",
        },
        {
          id: 3,
          icon: <Queries />,
          label: "Admin Employee Directory",
          path: "/adminemployeedirectory",
          description: "Loreum ipssum",
          color: "rgba(255, 0, 255, 0.5)",
        },
        {
          id: 4,
          icon: <ContactDetails />,
          label: "Update Team",
          path: "/orgProjects",
          description: "Loreum ipssum",
          color: "rgba(255, 87, 87, 0.15)",
        },
        {
          id: 5,
          icon: <ContactDetails />,
          label: "Create Roles",
          path: "/createRoles",
          description: "Loreum ipssum",
          color: "rgba(255, 0, 255, 0.5)",
        },
        {
          id: 16,
          icon: <Compenstation />,
          label: "Admin FAQ's",
          path: "/adminFaqs",
          description: "Loreum ipssum",
          color: "rgba(255, 160, 122, 0.719)",
        },
        {
          id: 55,
          icon: <MagReview />,
          label: "Applicants",
          path: "/applicants",
          color: "rgba(144, 238, 144, 0.781)",
        },
      ],
    },
  ];
  const adminNavbarMobile = [
    {
      heading: "My Self",
      list: [
        {
          id: 56,
          icon: <EmployeeDirectory />,
          label: "Insytix Employees",
          path: "/insytix-employees",
          color: "rgba(111, 45, 137, 0.25)",
        },
        {
          id: 6,
          icon: <MagReview />,
          label: "Admin Perfomance Tracking",
          path: "/adminPerformance",
          description: "Loreum ipssum",
          color: "rgba(255, 192, 203, 0.5)",
        },
        {
          id: 7,
          icon: <MagReview />,
          label: "HR Dashboard",
          path: "/adminleavemngmnt",
          color: "rgba(144, 238, 144, 0.781)",
        },
        {
          id: 8,
          icon: <Queries />,
          label: "Admin Employee Directory",
          path: "/adminemployeedirectory",
          description: "Loreum ipssum",
          color: "rgba(255, 0, 255, 0.5)",
        },
        {
          id: 9,
          icon: <ContactDetails />,
          label: "Update Team",
          path: "/orgProjects",
          description: "Loreum ipssum",
          color: "rgba(255, 87, 87, 0.15)",
        },
        {
          id: 10,
          icon: <ContactDetails />,
          label: "Create Roles",
          path: "/createRoles",
          description: "Loreum ipssum",
          color: "rgba(255, 0, 255, 0.5)",
        },
        {
          id: 11,
          icon: <Person />,
          label: "My Profile",
          path: "/myprofile",
          description: "Loreum ipssum",
          color: "rgba(255, 160, 122, 0.719) ",
        },
        {
          id: 12,
          icon: <LeaveManagement />,
          label: "Leave Management",
          path: "/leavemanagement",
          color: "rgba(216, 141, 216, 0.815)",
        },
        {
          id: 13,
          icon: <MagReview />,
          label: "Perfomance Tracking",
          path: "/mag",
          description: "Loreum ipssum",
          color: "rgba(122, 122, 221, 0.829) ",
        },
        {
          id: 14,
          icon: <EmployeeDirectory />,
          label: "Employee Directory",
          path: "/employeedirectory",
          description: "Loreum ipssum",
          color: "rgba(255, 165, 0, 0.5)",
        },
        {
          id: 15,
          icon: <Calendar />,
          label: "Team",
          path: "/projects",
          description: "Loreum ipssum",
          color: " rgba(255, 0, 255, 0.5)",
        },
        {
          id: 16,
          icon: <Compenstation />,
          label: "Benefits",
          path: "/benefits",
          description: "Loreum ipssum",
          color: "rgba(255, 160, 122, 0.719)",
        },
      ],
    },
  ];
  const navBarMyself = [
    {
      heading: "My Self",
      list: [
        {
          id: 17,
          icon: <Person />,
          label: "My Profile",
          path: "/myprofile",
          description: "Loreum ipssum",
          color: "rgba(255, 160, 122, 0.719) ",
        },
        {
          id: 18,
          icon: <LeaveManagement />,
          label: "Leave Management",
          path: "/leavemanagement",
          color: "rgba(216, 141, 216, 0.815)",
        },
        {
          id: 18,
          icon: <LeaveManagement />,
          label: "FAQ's",
          path: "/queries",
          color: "rgba(216, 141, 216, 0.815)",
        },
        {
          id: 19,
          icon: <MagReview />,
          label: "Perfomance Tracking",
          path: "/mag",
          description: "Loreum ipssum",
          color: "rgba(122, 122, 221, 0.829) ",
        },
        {
          id: 20,
          icon: <EmployeeDirectory />,
          label: "Employee Directory",
          path: "/employeedirectory",
          description: "Loreum ipssum",
          color: "rgba(255, 165, 0, 0.5)",
        },
        {
          id: 20,
          icon: <EmployeeDirectory />,
          label: "Timesheet",
          path: "/timesheet",
          description: "Loreum ipssum",
          color: "rgba(255, 165, 0, 0.5)",
        },
      ],
    },
    {
      heading: "Pay",
      list: [
        {
          id: 21,
          icon: <Compenstation />,
          label: "Benefits",
          path: "/benefits",
          description: "Loreum ipssum",
          color: "rgba(255, 160, 122, 0.719)",
        },
      ],
    },
    {
      heading: "Calendar",
      list: [
        {
          id: 22,
          icon: <EmployeeDirectory />,
          label: "Team",
          path: "/projects",
          description: "Loreum ipssum",
          color: " rgba(255, 0, 255, 0.5)",
        },
        {
          id: 23,
          icon: <Calendar />,
          label: "Pay Modules",
          path: "/pay",
          description: "Loreum ipssum",
          color: " rgba(255, 0, 255, 0.5)",
        },
      ],
    },
  ];
  const [repEmail, setRepEmail] = useState<any>([]);
  const getReportsToEmailFun = async () => {
    const orgId = auth?.userInfo?.orgs?.[0]?.id;
    const orgUserId = auth?.userInfo?.orgs_user_id?.[0];
    if (orgId == null || orgUserId == null) return;
    setRepEmail(await getReportsToEmail(orgId, String(orgUserId)));
    console.log("leave history details");
  };
  const navbarCompOff = [
    {
      heading: "Comp off",
      list: [
        {
          id: 23,
          icon: <Calendar />,
          label: "Comp Off",
          path: "/compoff",
          description: "Loreum ipssum",
          color: " rgba(255, 0, 255, 0.5)",
        },
      ],
    },
  ];
  console.log("User Info", repEmail?.[0]?.reports_to_id?.length > 0);

  useEffect(() => {
    getReportsToEmailFun();
  }, []);

  return (
    <NavbarSc>
      <div className="navbar_whole_component">
        <div className="nav-bar-left-side-logos">
          <div className="dropdown" onClick={() => setIsClick(!isClick)}>
            <div className="dropbtn">
              <img
                src={insytix}
                className="nav-bar-xbi4-white-logo-in "
                alt="xbi4"
                // onClick={() => navigate('')}
              />
            </div>
            <div
              className={`${
                isClick ? "dropdown_content_click" : "dropdown-content"
              }`}
            >
              <div className="icon-item">
                <label
                  onClick={() => {
                    navigate("/");
                    setIsClick(false);
                  }}
                >
                  Home
                </label>
              </div>
              <div className="wrap-container">
                {navBarMyself?.map((data, idx: any) => {
                  return (
                    <>
                      <div className="drop-down-list" key={idx}>
                        {data?.list?.map((data) => {
                          function handleMouseOver(event: any) {
                            const target = event.target;
                            if (target instanceof HTMLElement) {
                              target.style.backgroundColor = data?.color;
                              target.style.borderRadius = "3px";
                              target.style.transition =
                                "background-color .4s ease-in-out";
                              target.style.color = "whitesmoke";
                            }
                          }
                          function handleMouseOut(event: any) {
                            const target = event.target;
                            if (target instanceof HTMLElement) {
                              target.style.backgroundColor = "whitesmoke";
                              target.style.borderRadius = "3px";
                              target.style.color = "black";
                            }
                          }
                          return (
                            <>
                              <div
                                className="modules"
                                onMouseOver={handleMouseOver}
                                onMouseOut={handleMouseOut}
                                key={data?.id}
                              >
                                <div
                                  onClick={() => {
                                    {
                                      navigate(data.path);
                                    }
                                    setIsClick(false);
                                  }}
                                >
                                  {data?.icon} {""}
                                  {data.label}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </>
                  );
                })}

                {(user?.[0]?.is_admin === 1 ||
                  user?.[0]?.is_admin === true ||
                  user?.[0]?.is_admin === "1" ||
                  auth?.userInfo?.is_admin === 1 ||
                  auth?.userInfo?.is_admin === true ||
                  auth?.userInfo?.is_admin === "1") &&
                  adminNavbar?.map((data) => {
                    return (
                      <>
                        <div className="drop-down-list">
                          {data?.list?.map((data) => {
                            function handleMouseOver(event: any) {
                              const target = event.target;
                              if (target instanceof HTMLElement) {
                                target.style.backgroundColor = data?.color;
                                target.style.borderRadius = "3px";
                                target.style.transition =
                                  "background-color .4s ease-in-out";
                                target.style.color = "whitesmoke";
                              }
                            }
                            function handleMouseOut(event: any) {
                              const target = event.target;
                              if (target instanceof HTMLElement) {
                                target.style.backgroundColor = "whitesmoke";
                                target.style.borderRadius = "3px";
                                target.style.color = "black";
                              }
                            }
                            return (
                              <>
                                <div
                                  className="modules"
                                  onMouseOver={handleMouseOver}
                                  onMouseOut={handleMouseOut}
                                >
                                  <div onClick={() => navigate(data.path)}>
                                    {data?.icon} {""}
                                    {data.label}
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </>
                    );
                  })}
                {Boolean(user?.[0]?.is_people_lead) &&
                  adminPerformanceModule?.map((data) => {
                    return (
                      <>
                        <div className="drop-down-list">
                          {data?.list?.map((data) => {
                            function handleMouseOver(event: any) {
                              const target = event.target;
                              if (target instanceof HTMLElement) {
                                target.style.backgroundColor = data?.color;
                                target.style.borderRadius = "3px";
                                target.style.transition =
                                  "background-color .4s ease-in-out";
                                target.style.color = "whitesmoke";
                              }
                            }
                            function handleMouseOut(event: any) {
                              const target = event.target;
                              if (target instanceof HTMLElement) {
                                target.style.backgroundColor = "whitesmoke";
                                target.style.borderRadius = "3px";
                                target.style.color = "black";
                              }
                            }
                            return (
                              <>
                                <div
                                  className="modules"
                                  onMouseOver={handleMouseOver}
                                  onMouseOut={handleMouseOut}
                                >
                                  <div onClick={() => navigate(data.path)}>
                                    {data?.icon} {""}
                                    {data.label}
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </>
                    );
                  })}
                {!Boolean(repEmail?.[0]?.reports_to_id?.length > 0) &&
                  navbarCompOff?.map((data) => {
                    return (
                      <>
                        <div className="drop-down-list">
                          {data?.list?.map((data) => {
                            function handleMouseOver(event: any) {
                              const target = event.target;
                              if (target instanceof HTMLElement) {
                                target.style.backgroundColor = data?.color;
                                target.style.borderRadius = "3px";
                                target.style.transition =
                                  "background-color .4s ease-in-out";
                                target.style.color = "whitesmoke";
                              }
                            }
                            function handleMouseOut(event: any) {
                              const target = event.target;
                              if (target instanceof HTMLElement) {
                                target.style.backgroundColor = "whitesmoke";
                                target.style.borderRadius = "3px";
                                target.style.color = "black";
                              }
                            }
                            return (
                              <>
                                <div
                                  className="modules"
                                  onMouseOver={handleMouseOver}
                                  onMouseOut={handleMouseOut}
                                >
                                  <div onClick={() => navigate(data.path)}>
                                    {data?.icon} {""}
                                    {data.label}
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        <div className="hamburger-menu">
          <button
            className={`menu-button ${isOpen ? "open" : ""}`}
            onClick={handleMenuToggle}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
          {isOpen && (
            <div className="main-modal-container">
              {user?.[0]?.is_admin === 1 ||
              user?.[0]?.is_admin === true ||
              user?.[0]?.is_admin === "1" ||
              auth?.userInfo?.is_admin === 1 ||
              auth?.userInfo?.is_admin === true ||
              auth?.userInfo?.is_admin === "1" ? (
                adminNavbarMobile?.map((data, idx) => {
                  return <ToggleList data={data} idx={idx} onClick={data} />;
                })
              ) : (
                <div className="main-modal-container">
                  {navBarMyself?.map((data, idx) => {
                    return <ToggleList data={data} idx={idx} onClick={data} />;
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="navbar-rightside-comp">
          {homeData?.map((data) => {
            return (
              <>
                <div className="greeting-name">
                  Hello!{" "}
                  {[auth?.userInfo?.first_name, auth?.userInfo?.last_name]
                    .filter(Boolean)
                    .join(" ")}
                </div>
              </>
            );
          })}
          <div className="profile-dropdrown-background">
            <div className="profile-drop-down">
              <div className="navbar-profile-pic-btn">
                {auth?.userInfo?.first_name?.[0] || ""}
              </div>
              <div className="profile-pic-drop-down-content">
                <div className="t-icon" onClick={() => navigate("/myprofile")}>
                  Edit Profile
                  <img
                    src={EditProfile}
                    className="navbar-rightside-logout-logo"
                    alt="logout"
                  />
                </div>
                <div className="t-icon " onClick={auth?.signOut}>
                  {" "}
                  LogOut
                  <img
                    src={Logout}
                    className="navbar-rightside-logout-logo"
                    alt="logout"
                    onClick={auth?.signOut}
                  />
                </div>
                <div className="t-icon">
                  <a
                    href="https://www.xbi4.com/contactUs"
                    target="_blank"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Help and Support
                  </a>
                  <img
                    src={HelpandSupport}
                    className="navbar-rightside-logout-logo"
                    alt="logout"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Outlet />
      <div className="toast_container">
        <ToastContainer />
      </div>
    </NavbarSc>
  );
}

export default Navbar;
